import { IDictDateInputControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import { NamedDomain } from '../../../../infrastructure/schemas/storage/NamedDomain';
import {
  DictDateFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import {
  buildCommonDictionaryButtonModel,
  getDateFormatProps,
  getValueFromArgsOrConfig,
} from './helpers';

const buildDictDateControl = (
  domain: NamedDomain,
  item: IDictDateInputControl,
  localizedProps: LocalizedProps,
  source: FormSource,
  args: TActionArgsValues
): DictDateFormControlViewModel => {
  const formatProps = getDateFormatProps(domain);

  let value = getValueFromArgsOrConfig<Date | null>(item, args, source, null);
  if (value !== null) {
    value = new Date(value);
  }

  return {
    ...buildCommonDictionaryButtonModel(item, source),
    outParams: item.outParams,
    canClearOnReadOnly: item.canClearOnReadOnly,
    columns: item.columns,
    disabled: item.disabled,
    enableButtonOnReadOnly: source.type !== FormSourceType.REVIEW,
    hasHistory: false,
    hasValue: true,
    invalid: item.invalid,
    errorMessage: item.errorMessage,
    labelWidth: item.labelWidth,
    name: item.name,
    noLabel: item.noLabel,
    readonly: item.readonly || source.type === FormSourceType.REVIEW,
    required: item.required,
    storeValue: item.storeValue,
    type: FormControlViewModelType.DICT_DATE,
    updater: item.updater,
    value,
    visible: item.visible,
    ...formatProps,
    ...localizedProps,
  };
};

export default buildDictDateControl;
